import React, { memo } from 'react';
import { Box, Image } from 'components/Wrapped';

const OrderBookModeSelector = memo(({ orderMode, onChangeOrderMode }) => (
  <Box pad="none" direction="row" gap="3px">
    <Box
      background={orderMode === 'multi' ? 'rgba(255, 255, 255, 0.1)' : 'transparent'}
      pad="none"
      justify="center"
      align="center"
      round="50%"
      height="24px"
      width="24px"
      style={{ cursor: 'pointer' }}
      onClick={() => onChangeOrderMode('multi')}
    >
      <Image src="/assets/img/icons/multi_mode.svg" height="12px" width="12px" />
    </Box>
    <Box
      background={orderMode === 'buy' ? 'rgba(255, 255, 255, 0.1)' : 'transparent'}
      pad="none"
      justify="center"
      align="center"
      round="50%"
      height="24px"
      width="24px"
      style={{ cursor: 'pointer' }}
      onClick={() => onChangeOrderMode('buy')}
    >
      <Image src="/assets/img/icons/buy_mode.svg" height="12px" width="12px" />
    </Box>
    <Box
      background={orderMode === 'sell' ? 'rgba(255, 255, 255, 0.1)' : 'transparent'}
      pad="none"
      justify="center"
      align="center"
      round="50%"
      height="24px"
      width="24px"
      style={{ cursor: 'pointer' }}
      onClick={() => onChangeOrderMode('sell')}
    >
      <Image src="/assets/img/icons/sell_mode.svg" height="12px" width="12px" />
    </Box>
  </Box>
));

export default OrderBookModeSelector;
